import { getLegend, getTooltip, getXaxis, getYaxis } from "../tools";

const Aecharts = a => require(['@/components/Aecharts'], a);

export default {
  name: 'AeLine',
  props: {
    data: {
      type: Array,
      default: () => [
        { id: 1, name: '栏目一', value: [55, 43, 44, 32, 54, 31, 56, 23, 53, 12, 11, 21], color: '' },
      ]
    },
    series: { type: Object, default: () => [] },
    type: { type: String, default: () => 'line' },
    colors: { type: Array, default: () => ['#2f7ed8', '#0d233a', '#8bbc21', '#910000', '#1aadce', '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'] },
    smooth: { type: Boolean, default: () => true },
    xAxis: { type: Array, default: () => ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'] },
    showLegend: { type: Boolean, default: () => false },
    showTooltip: { type: Boolean, default: () => true },
    delay: { type: Number, default: () => 400 },
    backgroundColor: { type: String, default: () => '' },
  },
  data() {
    return {
      option: {},
    }
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler() {
        this.create();
      }
    },
    series: {
      deep: true,
      immediate: true,
      handler() {
        this.create();
      }
    }
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      const { data } = this;
      const series = data && data.length > 0 && data.map((a, b) => ({
        data: a.value,
        type: a.type ? a.type : this.type,
        smooth: this.smooth, // 圆滑折线角度
        areaStyle: { // 区域填充样式
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: 'rgba(58,132,255, 0.5)' // 0% 处的颜色
            }, {
              offset: 1, color: 'rgba(58,132,255, 0)' // 100% 处的颜色
            }],
            global: false // 缺省为 false
          }
        },
        animationDelay: c => c * b * 100,
        ...a,
      }));
      this.option = {
        backgroundColor: this.backgroundColor,
        legend: getLegend(this.showLegend),
        tooltip: getTooltip(this.showTooltip),
        grid: {
          show: false,
          top: 20,
          left: 0,
          right: 10,
          bottom: 0,
          containLabel: true,
        },
        xAxis: getXaxis(this.xAxis),
        yAxis: getYaxis(),
        series: [...series, ...this.series],
      };
    },
  },
  render() {
    const { option = {}, delay = 400, ...attrs } = this.$attrs;
    return (<Aecharts option={{ ...this.option, ...option }} delay={this.delay} {...{ attrs }} />);
  }
}